import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sign-up" }
const _hoisted_2 = {
  id: "support-edit-form-group-subject",
  class: "form__group"
}
const _hoisted_3 = {
  tabindex: "-1",
  role: "group"
}
const _hoisted_4 = { class: "shortform-sign-up__group" }

import { ref } from 'vue'

import BasePopup from '@/components/ui/BasePopup.vue'
import AppButton from '@/app/components/button/AppButton.vue'
import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'
import FormError from '@/components/ui/FormError.vue'
import { auth } from '@/services/auth'

import { ChangeEmailPopupView } from '@/models/settings'

export default /*@__PURE__*/_defineComponent({
  __name: 'ChangeEmailPopup',
  setup(__props, { expose: __expose }) {

const popup = ref<InstanceType<typeof BasePopup> | null>(null)
const emailInput = ref<InstanceType<typeof InputWithContextMenu> | null>(null)

const view = ref(new ChangeEmailPopupView())

async function show(): Promise<void> {
  view.value.validation.reset()
  view.value.initWithEmail(auth.getEmail() ?? '')
  popup.value?.show()
}

function hide(): void {
  popup.value?.hide()
}

async function submitForm(): Promise<void> {
  await view.value.submitForm()
  if (isSuccess()) {
    hide()
  }
}

function isSuccess(): boolean {
  return view.value.state === 'success'
}

__expose({
  show,
  hide,
  isSuccess,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasePopup, {
    ref_key: "popup",
    ref: popup,
    title: "Change email"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          class: "shortform-sign-up__form",
          onSubmit: _withModifiers(submitForm, ["prevent"])
        }, [
          _createElementVNode("fieldset", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[1] || (_cache[1] = _createElementVNode("label", { class: "form__label form__label--large" }, " Email address ", -1)),
              _createVNode(InputWithContextMenu, {
                id: "email-field",
                ref_key: "emailInput",
                ref: emailInput,
                modelValue: view.value.model.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((view.value.model.email) = $event)),
                modelModifiers: { trim: true },
                type: "text",
                autofocus: "",
                class: _normalizeClass([view.value.validation.stateClass('email'), "form-control"])
              }, null, 8, ["modelValue", "class"]),
              _createVNode(FormError, {
                errors: view.value.validation.errors,
                field: "email"
              }, null, 8, ["errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(AppButton, {
              id: "email-change-submit",
              class: "app-btn btns--yellow",
              type: "submit"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Save Changes ", -1)
              ]))]),
              _: 1
            })
          ])
        ], 32)
      ])
    ]),
    _: 1
  }, 512))
}
}

})